import React from 'react';

const InventryActiveIcon = () => {
  return (
    <svg width='24' height='25' viewBox='0 0 24 25' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        opacity='0.4'
        d='M20.1 7.68998C20.1 8.22998 19.81 8.71995 19.35 8.96995L17.61 9.90995L16.13 10.7L13.06 12.36C12.73 12.54 12.37 12.63 12 12.63C11.63 12.63 11.27 12.54 10.94 12.36L4.64999 8.96995C4.18999 8.71995 3.89999 8.22998 3.89999 7.68998C3.89999 7.14998 4.18999 6.65995 4.64999 6.40995L6.62 5.34996L8.19 4.49998L10.94 3.02C11.6 2.66 12.4 2.66 13.06 3.02L19.35 6.40995C19.81 6.65995 20.1 7.14998 20.1 7.68998Z'
        fill='#292D32'
      />
      <path
        opacity='0.4'
        d='M9.89492 13.5467L4.04491 10.6167C3.59491 10.3867 3.07492 10.4167 2.64492 10.6767C2.21492 10.9367 1.96493 11.3968 1.96493 11.8968V17.4267C1.96493 18.3867 2.49491 19.2467 3.35491 19.6767L9.20492 22.5968C9.40492 22.6968 9.62493 22.7467 9.84493 22.7467C10.1049 22.7467 10.3649 22.6768 10.5949 22.5268C11.0249 22.2668 11.2749 21.8067 11.2749 21.3067V15.7768C11.2849 14.8368 10.7549 13.9767 9.89492 13.5467Z'
        fill='#292D32'
      />
      <path
        opacity='0.4'
        d='M22.03 11.9002V17.4301C22.03 18.3801 21.5 19.2401 20.64 19.6701L14.79 22.6001C14.59 22.7001 14.37 22.7501 14.15 22.7501C13.89 22.7501 13.63 22.6802 13.39 22.5302C12.97 22.2702 12.71 21.8101 12.71 21.3101V15.7901C12.71 14.8301 13.24 13.9701 14.1 13.5401L16.25 12.4701L17.75 11.7201L19.95 10.6201C20.4 10.3901 20.92 10.4101 21.35 10.6801C21.77 10.9401 22.03 11.4002 22.03 11.9002Z'
        fill='#292D32'
      />
      <path
        d='M17.61 9.90997L16.13 10.7L6.62 5.34998L8.19 4.5L17.37 9.67999C17.47 9.73999 17.55 9.81997 17.61 9.90997Z'
        fill='#292D32'
      />
      <path
        d='M17.75 11.7197V13.9897C17.75 14.3997 17.41 14.7397 17 14.7397C16.59 14.7397 16.25 14.3997 16.25 13.9897V12.4697L17.75 11.7197Z'
        fill='#292D32'
      />
    </svg>
  );
};

export default InventryActiveIcon;
